import { render, staticRenderFns } from "./role-add.vue?vue&type=template&id=1854e2e9&scoped=true&"
import script from "./role-add.vue?vue&type=script&lang=js&"
export * from "./role-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1854e2e9",
  null
  
)

export default component.exports